import {uiMsg,installLanguage} from '../utils/Languages';
import {autorun, when, transaction} from 'mobx';
import AppModel from './AppModel';
import Promise from 'bluebird';
Promise.config({
  longStackTraces: true
});

import XLSX from "xlsx";
import { saveAs } from 'file-saver';
import ServerAPI from '../ServerAPI';
import Machine from './Machine';
import Location from './Location';
import Job from './Job';
import JobType from './JobType';
import LocationType from './LocationType';
import User from './User';
import Role from './Role';
import Customer from './Customer';
import Contract from './Contract';
import * as LoadLevel from './LoadLevel';
import {switchUser,logout} from '../utils/LoginHelper';
import RC from '../utils/ReactiveClock';
import moment from "moment";

import { showTemporaryUIMessage,
    showTemporaryUndoMessage,
    uiErrorDisplay,
    clearUIMessage} from '../utils/UIMessageBoxes.js';
import Beacon from './Beacon';
import SimCard from './SimCard';
import s2ab from '../utils/s2ab';

// -------------------------------------------------------------------
// -PULL status info related code START
// -------------------------------------------------------------------
// This module-local status keeps track of whether we are currently
// pulling status of a set of Jobs regularly :
var nextPullOperation = null;
var pullInterval = AppModel.node_env()=='development' ? 5000 : 30000;
// The pullOperation fetches updates to the data that we need to track.
// Then decides if we need to keep pulling.  If so, it schedules a new
// pull operation :
function pullOperation() {
  nextPullOperation=null;
  // We fetch all timestamped updates from machines with running jobs,
  // newer than the newest timestamp from last update.
  if(!AppModel.someJobRequirePolling) return;
  // If we are already waiting for an update :
  if(AppModel.fetchingJobUpdates) return;
  console.log("Polling data for machines : "+AppModel.machineIdsToPollForData.join(","));
  // This should be true until the request return:
  AppModel.fetchingJobUpdates = true;
  ServerAPI.getJobDetails(AppModel.id_customer,
                          AppModel.machineIdsToPollForData,
                          AppModel.timeStampLastJobUpdate)
  .then((eventRows)=>{
    // Update job objects from DB updates :
    // Update the timestamp for most recently received measurement :
    var maxTime = AppModel.timeStampLastJobUpdate;
    eventRows.forEach( (ev) => {
      var d = new Date(ev.ts);
      if(maxTime==null || ( d > maxTime ) ) {
        maxTime = d;
      }
    });
    // Create a lookup map of the id_machine to our machine objects:
    var machineMap = {}
    eventRows.forEach( (ev) => {
      var mid = ev.id_machine;
      if(!(mid in machineMap)) {
        var m = AppModel.findMachine(mid);
        if(!m) {
          //Set a placeholder
          machineMap[mid] = AppModel.setCurrentMachine(mid);
        } else {
          machineMap[mid] = m;
        }
      }
    });
    // Find the LAST_MEASUREMENT special event
    eventRows
      .filter( (ev) => {return ev.event=='LAST_MEASUREMENT'} )
      .forEach( (ev) => {
        var m = machineMap[ev.id_machine];
        if(!m) {
          console.error("Did not find machine to write event-data to");
          return;
        }
        if(!m.last_job) {
          console.log("Machine does not have a last_job .. ?");
          console.log(m);
          return;
        }
        var evTime = new Date(ev.ts);
        m.last_job.last_measurement_time = evTime;
        m.last_job.checkIfOffline();
      });

    // Write the measurements to the current job of the relevant machine.
    // The observable - transaction wrapper avoids the graph being re-rendered for every
    // single measurement data point.
    transaction( () => {
      eventRows
      .filter( (ev) => {return ev.event=='MEASURE'} )
      .forEach( (ev) => {
        var m = machineMap[ev.id_machine];
        if(!m) {
          console.error("Did not find machine to write event-data to");
          return;
        }
        if(!m.last_job) {
          console.log("Machine does not have a last_job .. ?");
          console.log(m);
          return;
        }
        var evTime = new Date(ev.ts);
        if(evTime < m.last_job.start_time) {
          // This event belonged to the job before this one (may happen)
          return;
        }
        m.last_job.addMeasurement(ev.name, evTime, ev.value, ev.sensor_index);
      });
    });
    // Update the Phase-info on the running job:
    eventRows
      .filter( (ev) => {return ev.event.startsWith('PHASE')} )
      .forEach( (ev) => {
        //console.log("PhaseEvent",ev);
        var m = machineMap[ev.id_machine];
        if(!m) {
          console.error("Did not find machine to write phase event to");
          return;
        }
        var evTime = new Date(ev.ts);
        if(evTime < m.last_job.start_time) {
          // This event belonged to the job before this one (may happen)
          return;
        }
        if(ev.event.endsWith('START')) {
          m.last_job.startPhase(ev.name, evTime);
        }
        if(ev.event.endsWith('END')) {
          m.last_job.endPhase(ev.name, evTime);
        }
      });
    // Find the SECONDS_REMAIN special events that gives updates on
    // seconds remaining for running jobs.
    eventRows
      .filter( (ev) => {return ev.event=='SECONDS_REMAIN'} )
      .forEach( (ev) => {
        var m = machineMap[ev.id_machine];
        if(!m) {
          console.error("Did not find machine to write seconds remaining update");
          return;
        }
        if(!m.last_job) {
          console.log("Machine does not have a last_job .. ?");
          console.log(m);
          return;
        }
        m.last_job.seconds_remain = +ev.value;
        console.log("Updating seconds remaining to "+m.last_job.seconds_remain);
        m.last_job.seconds_remain_set_at = new Date();
      });
    // Collect the alarms for the job
    eventRows
      .filter( (ev) => {return ev.event.startsWith('ALARM')} )
      .forEach( (ev) => {
        //console.log("PhaseEvent",ev);
        var m = machineMap[ev.id_machine];
        if(!m) {
          console.error("Did not find machine to write phase event to");
          return;
        }
        var evTime = new Date(ev.ts);
        if(evTime < m.last_job.start_time) {
          // This event belonged to the job before this one (may happen)
          return;
        }
        m.last_job.alarms.push(ev);
      });

    // Next time, we should only fetch updates newer than this timestamp :
    AppModel.timeStampLastJobUpdate = maxTime;
    //console.log("Last event time recieved : ",AppModel.timeStampLastJobUpdate);

    // Finally, we see if we should end some jobs :
    eventRows.filter( (ev) => {return ev.event=='JOB_END'; })
    .forEach( (ev) => {
      console.log("JOB_END event",ev);
      var m = machineMap[ev.id_machine];
      if(!m) {
        console.error("Did not find machine to end job for");
        return;
      }
      var evTime = new Date(ev.ts);
      // If the end happened before this job started, then it belonged to
      // a prior job.
      if(evTime < m.last_job.start_time) {
        return;
      }
      // Setting end time for job :
      m.last_job.end_time = evTime;
      // Setting the status of the job
      // which is stored in the "name" field of the event.
      m.last_job.status = ev.name;

    });
    // If we still have jobs running after the update, we schedule a new
    // pull in pullInterval ms.
  })
  .catch((error) => {
    console.error("Error trying to PULL an update on ");
    console.error(error);
  })
  .finally(()=>{
    // Reset the "now" timestamp used in reactive computations.
    RC.tickClock();
    // We are no longer waiting for the request to return:
    AppModel.fetchingJobUpdates = false;
    if(AppModel.someJobRequirePolling) {
        nextPullOperation=setTimeout(pullOperation,pullInterval);
    }
  })
}
// Not sure when we need to do this, but if this method is called, there
// should not be another pull op.
function stopPulling() {
  clearTimeout(nextPullOperation);
  nextPullOperation=null;
}
// Helper method that starts the pull-operation if not running already:
function verifyStatusPullOperation() {
  if(!nextPullOperation && AppModel.someJobRequirePolling) {
    nextPullOperation=setTimeout(pullOperation,0);
  }
}
// -------------------------------------------------------------------
// -PULL status info related code END
// -------------------------------------------------------------------

var utils = {


  sendTestSMS(user) {
    AppModel.sendingTestSMS = true;
    return ServerAPI.sendTestSMS(user.id_customer,user.id)
    .then(rows => {
      showTemporaryUIMessage(uiMsg('CMSG_SMS_SENT_TO_PHONE',"Test SMS sent to X",user.phone));
    })
    .catch( error => {
      uiErrorDisplay(error);
    })
    .finally( ()=> {
      AppModel.sendingTestSMS = false;
    })
  },

  activateSimCard(machine) {
    AppModel.changingSIMCardActivationStatus = true;
    return ServerAPI.activateSimCard(machine.id, machine.iccid)
    .then( res => {
      // TODO : Update the status based on the response value
      console.log(res);
      machine.sim_activation_status='activated';
      showTemporaryUIMessage(uiMsg('MP_SIM_ACTIVATED',"SIM card activated"));
      
    })
    .catch( error => {
      if(error.status == 412){
        machine.sim_activation_status='activated';
        showTemporaryUIMessage(error.responseText)
      }else{
        uiErrorDisplay(error);
      }
    })
    .finally( ()=> {
      AppModel.changingSIMCardActivationStatus = false;
    })
  },

  deactivateSimCard(machine) {
    AppModel.changingSIMCardActivationStatus = true;
    return ServerAPI.deactivateSimCard(machine.id, machine.iccid)
    .then( res => {
      // TODO : Update the status based on the response value
      console.log(res);
      machine.sim_activation_status='deactivated';
      showTemporaryUIMessage(uiMsg('MP_SIM_DEACTIVATED',"SIM card deactivated"));
    })
    .catch( error => {
      uiErrorDisplay(error);
    })
    .finally( ()=> {
      AppModel.changingSIMCardActivationStatus = false;
    })
  },


  runMachineSearch() {
    AppModel.runningMachineSearch = true;
    // For now the only search parameter we have is the customer-id
    let searchParams={id_customer:AppModel.machineSearchForm.customer.id};
    return ServerAPI.machineSearch(searchParams)
    .then(machineRows => {
      // The machines found are stored in the machineSearchResult list
      AppModel.machineSearchResult = machineRows.map(Machine.createFromDBRow);
    })
    .catch( error => {
      uiErrorDisplay(error);
    })
    .finally( ()=> {
      AppModel.runningMachineSearch = false;
    })
  },

  loadLocationTypes() {
    AppModel.fetchingLocationTypes = true;
    return ServerAPI.findLocationTypes()
    .then(rows => {
      AppModel.locationTypes = rows.map(LocationType.createFromDBRow);
    })
    .catch( error => {
      uiErrorDisplay(error);
    })
    .finally( ()=> {
      AppModel.fetchingLocationTypes = false;
    })
  },

  requestPDFReportResend:function(job) {
    if(!job.end_time) {
      console.error("Report requested for job that hasn't completed.");
      return;
    }
    AppModel.requestingEmailReport = true;
    ServerAPI.queueEmailReport(job.id_machine, job.end_time)
    .then( result => {
      console.log(result);
      showTemporaryUIMessage(uiMsg('CMSG_REPORT_EMAILED_TO',
        "Report will be emailed to X",AppModel.userInfo.email));
    })
    .catch( error => {
      uiErrorDisplay(error);
    })
    .finally(()=>{
      AppModel.requestingEmailReport = false;
    });
  },
  fetch_location_details:function(params) {
    // Make sure that all locations details are loaded :
    return this.fetch_locations()
    .then(function() {
      // Then set the current location to the one with the URL id:
      AppModel.setCurrentLocation(params.id_location);
      // Copy values from the location to edit to the update form
      // (So that if the user clicks cancel, no changes have been made to the
      //  original )
      Object.assign(AppModel.updateRoomForm.location,AppModel.currentLocation);
      if(AppModel.updateRoomForm.location.id_parent==null) {
        // Not sure this is how this should be done, but in the form UI,
        // it seems we need a non-null value to pick meaning top-level
        AppModel.updateRoomForm.location.id_parent="root";
      }
    })
  },
  // When the update-user form has been filled in, this method will
  // post it to the server
  updateOrDeleteUser:function() {
    var form = AppModel.updateUserForm;
    // In case users delete phone number using space-bar
    if(form.user.phone && form.user.phone.trim) {
      form.user.phone=form.user.phone.trim();
    }
    // If the user removes the phone number, then they cannot receive SMS:
    if(!form.user.phone) {
      form.user.receiveSMSNotifications=false;
    }
    form.serverOperation.waiting=true;
    // 'root' is used as placeholder value in input form for root-area
    // as null value causes issue there..
    if(form.user.id_home_location=='root') {
      form.user.id_home_location=null;
    }
    // In case the id has changed we need to inform the server about the
    // new id:
    if(form.idChanged) {
      // The server side expect the user.id to be the existing id, and the
      // new id to be passed in as "new_id" on the user object.
      var new_id = form.user.id;
      form.user.id=form.prev_id; /* NB! this makes form.idChanged incorrect
      so don't use in logic from here on.*/
      form.user.new_id=new_id;
    }
    // the server
    return ServerAPI.updateOrDeleteUser(AppModel.id_customer,form.user)
    .then(function(result){
      // If the id was updated, flip the new id back into the user object
      if(form.user.new_id) {
        form.user.id=form.user.new_id;
      }
      // Update the user list :
      form.user.password = null;
      form.user.repeat_password = null;
      // Check to see if the user that was updated is in the userList
      var userIndex = AppModel.userList.findIndex( (u) => {
        return u.id==form.prev_id
      });
      if(userIndex!=-1) {
        if(form.user.deleted) {
          // Remove the deleted list from the userList
          AppModel.userList.splice(userIndex,1);
          // Since deleting a user will change the user count of locations:
          AppModel.clearLocationDataForReload();
        }
        else {
          // Copy the updated values back to the user object
          AppModel.userList[userIndex].copyFieldsFrom(form.user);
          // If the phone has been changed, it will need to be re-confirmed
          if(form.phoneChanged) {
            AppModel.userList[userIndex].phone_verified = false;
            form.user.phone_verified = false;
          }
        }
      }
      // If the update is for the logged in user :
      if(form.prev_id == AppModel.userInfo.id &&
        form.user.id_customer == AppModel.userInfo.id_customer
      ) {
        // Copy the updated values back to the user object
        AppModel.userInfo.copyFieldsFrom(form.user);
        // The AppModel.id_user is the id of the logged in user.
        if(form.user.new_id) {
          // If the user changed her own id, we have to make her log in again
          // if not the log-in token will hold the wrong user id
          logout();
        }
        // If the phone has been changed, it will need to be re-confirmed
        if(form.phoneChanged) {
          AppModel.userInfo.phone_verified = false;
          form.user.phone_verified = false;
        }
      }
      AppModel.userList.sort(function(a,b){
        if(a.name < b.name) return -1;
        else if (a.name > b.name) return 1;
        else return 0;
      });
      if(form.user.deleted) {
        // Invalidate the list of deletions (if loaded):
        AppModel.clearDeletionsListForReload();
        // Copy the Id as the form might be reset before user clicks:
        var undeleteUserUndoId = form.user.id;
        showTemporaryUndoMessage(uiMsg('CMSG_USER_DELETED',
          "User X deleted",form.user.id),()=>{
            // The undo action, if user clicks UNDO
            utils.undeleteUser(undeleteUserUndoId);
        });
      }
      else {
        showTemporaryUIMessage(uiMsg('CMSG_USER_UPDATED',
          "User X updated",form.user.id));
      }
      // If we don't return null, we will get a warning from the promise library
      // about a disconnected promise that are created in a autorun action due to
      // modification done to AppModel.userInfo.
      return null;
    })
    .catch( (error) => {
      console.log(error);
      AppModel.uiError="Unable to update data. "+error.responseText;
      throw new Error(error);
    })
    .finally( ()=> {
      form.serverOperation.waiting=false;
    })
  },
  // When the update-location form has been filled in, this method will
  // post it to the server and update the location tree based on the reply:
  updateOrDeleteLocation:function() {
    let form = AppModel.updateRoomForm;
    form.location.trimNumericFields();
    form.serverOperation.waiting=true;
    // Dealing with the odd issue of "root" locations
    if(form.location.id_parent=='root') {
      form.location.id_parent=null;
    }
    return ServerAPI.updateOrDeleteLocation(AppModel.id_customer,
                                            form.location)
    .then(function(result){
      // If the update succeeded on the DB side, we have to update the local
      // data structure to match what a reload would create :
      var updateLocation = AppModel.findLocationWithId(form.location.id);
      if(!updateLocation) throw new Error("System error. "+
        " Cannot find updated/deleted location locally");
      if(form.location.deleted) {
        // Invalidate the list of deletions (if loaded)
        AppModel.clearDeletionsListForReload();
        // This was a delete operation,
        var undeleteLocationId = form.location.id;
        showTemporaryUndoMessage(uiMsg('CMSG_LOCATION_DELETED',
          "Location X deleted",form.location.name),
          ()=>{
            // The undo action, if user clicks UNDO
            utils.undeleteLocationsById(undeleteLocationId)
            .then(res => {
              showTemporaryUIMessage(uiMsg('CMSG_LOCATION_RESTORED',"Location restored"));
              return null;
            })
            .catch(uiErrorDisplay);
        });
        // remove the location from client side cachel
        // If the deleted location had a parent location, we need to remove it
        // location tree:
        if(updateLocation.parent) {
          var index = updateLocation.parent.children.indexOf(updateLocation);
          if(index > -1 ) {
            updateLocation.parent.children.splice(index,1);
            updateLocation.parent=null;
          }
        }
        else // The location was a root location
        {
          var index = AppModel.userLocations.indexOf(updateLocation);
          if(index > -1 ) {
            AppModel.userLocations.splice(index,1);
          }
        }
      }
      else // This was not a delete operation, but an update :
      {
        // copy over relevant values :
        console.log("Putting updated location data back into App state");
        updateLocation.name = form.location.name;
        updateLocation.volume_m3 = form.location.volume_m3;
        updateLocation.height = form.location.height;
        updateLocation.length = form.location.length;
        updateLocation.width = form.location.width;
        updateLocation.id_type = form.location.id_type;
        updateLocation.type = form.location.type;
        updateLocation.default_job_type = form.location.default_job_type;
        updateLocation.beacons = form.location.beacons;
        var beacon_index = form.location.beacons.indexOf(form.location.new_beacon_id);
        if(beacon_index==-1){
          console.log("Adding beacon", beacon_index)
          utils.remove_beacon_from_appstate(form.location.new_beacon_id)
          updateLocation.beacons.push(form.location.new_beacon_id);
        }
        // We may have to move the location around.
        if(updateLocation.id_parent != form.location.id_parent) {
          // We have to move the location to a new parent :
          // If there is an existing parent, we remove it from that :
          if(updateLocation.parent) {
            var index = updateLocation.parent.children.indexOf(updateLocation);
            if(index > -1 ) {
              updateLocation.parent.children.splice(index,1);
            }
          } else {
            // If the location had no parent, we remove it from the root
            // set AppModel.userLocations
            var index = AppModel.userLocations.findIndex( l => l.id==updateLocation.id );
            if(index > -1 ) {
              AppModel.userLocations.splice(index,1);
            }
          }
          // Then look up the new parent (unless it is null):
          if(form.location.id_parent) {
            var newParent = AppModel.findLocationWithId(form.location.id_parent);
            if(!newParent) throw new Error("System error. "+
              " Cannot find parent location to move location to.");
            updateLocation.id_parent = newParent.id;
            updateLocation.parent = newParent;
            newParent.children.push(updateLocation);
            // Sort the new child-set by name:
            newParent.children.sort(function(a,b){
              if(a.name < b.name) return -1;
              else if (a.name > b.name) return 1;
              else return 0;
            });
          }
          else {
            // Location has been moved to the root.
            updateLocation.id_parent = null;
            updateLocation.parent = null;
            AppModel.userLocations.push(updateLocation);

          }
        }
        showTemporaryUIMessage(uiMsg('CMSG_LOCATION_UPDATED',
          "Location X updated",updateLocation.name
        ));
      }
    })
    .catch( (error) => {
      console.log(error);
      AppModel.uiError="Unable to update data. "+error.responseText;
      throw new Error(error);
    })
    .finally( ()=> {
      form.serverOperation.waiting=false;
    })
  },
  remove_beacon_from_location:function(beacon_id) {
    return ServerAPI.removeBeaconFromLocation(AppModel.id_customer, beacon_id)
    .then(function(res){
        utils.remove_beacon_from_appstate(beacon_id);
    })
  },
  remove_beacon_from_appstate: function(beacon_id){
    var flat_tree = [];
    function create_flat_tree(parent){
      for (const child of parent) {
        flat_tree.push(child);
        create_flat_tree(child.children)
      }
    }
    create_flat_tree(AppModel.userLocations);
    
    function organize_flat_tree(flat_tree) {
      // The location list we receive is a flattened tree.
      var id_to_node={};
      // Index the locations:
      flat_tree.forEach(function(loc) {
        id_to_node[loc.id]=loc;
        loc.children=[];
      });
      // Set up parent and child relations:
      flat_tree.forEach(function(loc) {
        // If the path only contains the id of the location itself:
        if(loc.path.length<2) {
          loc.parent=null;
        }
        else {
          var id_parent = loc.path[loc.path.length-2]
          loc.parent=id_to_node[id_parent];
          loc.id_parent=id_parent;
          // If we only load a subset of locations down the tree, we may not
          // have the actual parent :
          if(loc.parent) {
            loc.parent.children.push(loc);
          }
        }
      });
      // The location tree starts with the list of root-locations that do
      // not have a parent node :
      var rootLocations = flat_tree.filter(function(loc){
        return loc.parent==null;
      });
      return rootLocations;
    };

    for (let i = 0; i < flat_tree.length; i++) {
      for (let j = 0; j < flat_tree[i].beacons.length; j++) {
        if (flat_tree[i].beacons[j] == beacon_id){
          flat_tree[i].beacons.splice(j, 1);
        }
      }
    }

    AppModel.userLocations = organize_flat_tree(flat_tree);
  },
  fetch_machine_details:function(params) {
    // Get a machine object from the data model with this id, and
    // make it the current machine.  This may be a newly created object
    // with only the id set.
    var machine = AppModel.setCurrentMachine(params.id_machine);
    // If we do not have a id_customer parameter, we assume the currently
    // logged in user should be used for looking up customer specific machine details.
    var id_customer = params.id_customer || AppModel.userInfo.id_customer;
    // Make sure that all details are loaded for this machine
    if(machine.load_level ==  LoadLevel.DETAIL) { return Promise.resolve(); }
    machine.loading = true;
    AppModel.fetchingMachineDetails = true;
    return ServerAPI.getMachineDetails(id_customer, machine.id)
    .then((res)=>{
      var dbMachine = Machine.createFromDBRow(res);
      console.log(res);
      // Copy over the details from the machine object from the DB
      machine.updateFrom(dbMachine);
      let c = Contract.createFromDBRow(res);
      machine.contract = c;
      // If we have a simcard id, we fetch the sim card activation status:
      // This is delayed though, we will return the machine before this returns.
      if(machine.iccid!=null) {
        AppModel.fetchingSimActivationStatus=true;
        ServerAPI.getSimCardInfo(machine.iccid)
        .then( simInfo => {
          let sim = simInfo.shift() 
          machine.simcard = SimCard.createFromDBRow(sim)
          
          machine.sim_activation_status=sim.status;
          return null;
        })
        .finally( ()=> {
          AppModel.fetchingSimActivationStatus=false;
        })
      }
      return machine;
    })
    .catch( (error) => {
      console.log(error);
      AppModel.uiError="Unable to fetch data for machine. Check internet connection.";
    })
    .finally( ()=> {
      machine.loading=false;
      AppModel.fetchingMachineDetails = false;
    })
  },

  // Machine assignement history
  // from audit table
  //
  fetch_machine_history:function(params){
    // Get a machine object from the data model with this id, and
    // make it the current machine.  This may be a newly created object
    // with only the id set.
    let id_machine = params.id_machine;

    var machine = AppModel.setCurrentMachine(id_machine);

    AppModel.fetchingMachineDetails=true;
    return ServerAPI.getMachineHistory(id_machine)
    .then(res => {
      machine.history = res;
    })
    .catch( (error) => {
      console.log(error);
    })
    .finally( ()=> {
      AppModel.fetchingMachineDetails = false;
    })
  },
  // Set action on machine
  stop_process:function(job){
    // Get a machine object from the data model with this id, and
    // make it the current machine.  This may be a newly created object
    // with only the id set.
    let { id_machine, start_time, machine_name } = job;
    return ServerAPI.setMachineAction(id_machine, start_time, "STOP")
    .then(res => {
      job.machine_action = "STOP"
      showTemporaryUIMessage(uiMsg('CMSG_MACHINE_STOPPING',"X will stop the current process", machine_name));
    })
    .catch( (error) => {
      showTemporaryUIMessage(uiMsg('CMSG_MACHINE_STOP_ERROR',"Could not send stop signal to this machine"));
    })
  },
  // Each machine may have a different name for different customers.
  // When assigning machines to new (or previous) customers, we look up
  // to see if there are existing names stored for that machine+customer combo
  lookupMachineNameForCustomer(form) {
    let machine = form.machine;
    let customer = form.customer;
    let key = customer.id +":" +machine.id;
    if(AppModel.customerMachineNames.has(key)) {
      let name = AppModel.customerMachineNames.get(key);
      machine.name = name;
      return;
    }
    AppModel.fetchingMachineName = true;
    return ServerAPI.machineName(customer.id, machine.id)
      .then( name => {
        console.log("ServerAPI.machineName = "+name);
        AppModel.customerMachineNames.set(key,name);
        machine.name = name;
      })
      .finally( ()=> {
        AppModel.fetchingMachineName = false;
      })
  },

  // Wait for machine details to be loaded, then setup the form for updating
  // machine assignment:
  setupMachineAssignmentForm(params) {
    let machinePromise = utils.fetch_machine_details(params);
    // When the machine details have been loaded, we initialize the
    // machine assignment form
    machinePromise.then( (machine) => {
      let form = AppModel.machineAssignmentForm;
      form.machine = new Machine();
      form.machine.id=machine.id;
      form.machine.updateFrom(machine);
      if(AppModel.customerIdMap.has(machine.id_customer)) {
        form.customer = AppModel.customerIdMap.get(machine.id_customer);
        form.customer_search_text = form.customer.name;
      }
    });
    return machinePromise;
  },
  // Request server to assign given machine to specified customer:
  assignMachine() {
    let form = AppModel.machineAssignmentForm;
    let machine = form.machine;
    let customer = form.customer;
    AppModel.updatingMachineAssignment=true;
    return ServerAPI.assignMachine({
        id_customer:customer.id,
        id_machine:machine.id,
        customer_machine_name:machine.name
      }).then( result => {
        console.log("Machine assignment complete ",result);
      })
      .finally( ()=> {
        AppModel.updatingMachineAssignment=false;
      })
  },
  // Reset the machine config form and fill it with config parameter values from the
  // provided machine object:
  initMachineConfigForm:function(machine) {
    let form = AppModel.machineConfigurationForm;
    form.reset();
    form.machine=machine;
    machine.configuration.forEach(configParam => {
      form.parameters.push(configParam.clone());
    })
  },
  fetch_machine_config_details:function(params) {
    let machinePromise = utils.fetch_machine_details(params);
    // When the machine details have been loaded, we initialize the
    // machine config edit form :
    machinePromise.then( utils.initMachineConfigForm );
    return machinePromise;
  },

  resetMachineForm:function() {
    AppModel.newMachineForm.machine.reset();
  },
  resetRunningTime(machine, component_csv) {
    AppModel.changingRunningTime = true;
    return ServerAPI.resetRunningTime(machine.id, component_csv)
    .then( res => {
      const compArray = component_csv.split(',');
      if(compArray.includes("Compressor")) {
        machine.running_time_compressor=null;
        machine.last_reset_timestamp_compressor=null;
      }
      if(compArray.includes("LiquidPump")) {
        machine.running_time_liquid_pump=null;
        machine.last_reset_timestamp_liquid_pump=null;
      }
      if(compArray.includes("AirFilter")) {
        machine.running_time_air_filter=null;
        machine.last_reset_timestamp_air_filter=null;
      }
      showTemporaryUIMessage(uiMsg('MP_RUNNING_TIME_RESET',"Running time reset"));
    })
    .catch( error => {
      uiErrorDisplay(error);
    })
    .finally( ()=> {
      AppModel.changingRunningTime = false;
    })
  },
  // Use the filled in newUser form and post an INSERT operation to the
  // server.
  registerNewUser:function() {
    var form = AppModel.newUserForm;
    var operation = form.serverOperation;
    var user = form.user;
    // 'root' is used as placeholder value in input form for root-area
    // as null value causes issue there..
    if(user.id_home_location=='root') {
      user.id_home_location=null;
    }
    // When INSERT have been sent to server, until we receive
    operation.waiting=true;
    return ServerAPI.insertNewUser(user)
      .then((result) => {
        // Received result, stop spinners:
          operation.waiting=false;
          console.log(result);
          showTemporaryUIMessage(uiMsg('CMSG_USER_REGISTERED',"User X Registered",form.user.id));
          AppModel.userList.push(user);
          AppModel.userList.sort(function(a,b){
            if(a.name < b.name) return -1;
            else if (a.name > b.name) return 1;
            else return 0;
          });
          // Clear existing ghost object
          form.reset();
      })
      .catch((error) => {
          // The server request failed for some reason.
          console.error(error);
          operation.waiting=false;
          operation.result="FAIL";
          operation.message = error.responseText;
          throw new Error(error);
      })
  },
  // Use the filled in newMachine form and post an INSERT operation to the
  // server.
  registerNewMachine:function() {
    var operation = AppModel.newMachineForm.serverOperation;
    var machine = AppModel.newMachineForm.machine
    // When INSERT have been sent to server, until we receive
    operation.waiting=true;
    return ServerAPI.insertNewMachine(machine)
      .then((result) => {
        // Received result, stop spinners:
          operation.waiting=false;
          console.log(result);
          showTemporaryUIMessage(uiMsg('CMSG_NEW_MACHINE_INSERTED',"New machine inserted"));
          // TODO,Insert it into the machine-array when server says OK.
          AppModel.machineList.push(machine.clone());
          // Clear existing ghost object
          machine.reset();
      })
      .catch((error) => {
          // The server request failed for some reason.
          console.error(error);
          operation.waiting=false;
          operation.result="FAIL";
          operation.message = error.responseText;
          throw new Error(error);
      })
  },

  registerMultipleLocations:function(csvData, report) {
    var parent = AppModel.newRoomForm.location.id_parent;
    var operation = AppModel.newRoomForm.serverOperation;
    // When INSERT have been sent to server, until we receive
    operation.waiting=true;
    // If the location is set to "root", it really means "null"
    // the "root" value is due to the form UI
    if(parent=='root') {
      parent=null;
    }
    const locations = csvData.map(data => {
       let loc = data.location;
       loc.id_parent = parent;
       return loc;
    });
    const promises = locations.map(loc => ServerAPI.insertNewLocation(AppModel.id_customer, loc)).map(p => p.catch(e => e));;
    return Promise.all(promises)
      .then((results) => {
          // Inserting the new location into the location tree:
          let resultData = [
            ["parent_name", "name", "id_type", "width", "height", "length", "default_job_type", "beacon", "result"]
          ];
          transaction(function(){
            locations.forEach((nl, i) => {
              const result = results[i][0]
              // There is only supposed to be a single row returned with the ID
              // of the newly inserted location.
              nl.id = result.id;

              var parent = nl.id_parent != null ? AppModel.findLocationWithId(nl.id_parent) : null;

              resultData.push([nl.id_parent ? parent.name : "", nl.name, nl.id_type, nl.width, nl.height, nl.length, nl.default_job_type, nl.new_beacon_id, result.id ? "success" : `failure: ${JSON.stringify(result)}`])
              if(nl.new_beacon_id !== undefined && nl.new_beacon_id !== null){
                utils.remove_beacon_from_appstate(nl.new_beacon_id);
                nl.beacons = [nl.new_beacon_id];
                nl.new_beacon_id = undefined;
              }
              // Finding the parent in the tree, if id_parent!=null
              if(parent !=null) {
                nl.parent = parent;
                parent.children.push(nl);
                parent.children.sort(function(a,b){
                  if(a.name < b.name) return -1;
                  else if (a.name > b.name) return 1;
                  else return 0;
                });
              }
              else
              {
                // Insert location as new root in the location tree:
                AppModel.userLocations.push(nl);
              }
            })
            AppModel.newRoomForm.clearForNext();
          });
          if(report){
            const worksheet = XLSX.utils.aoa_to_sheet(resultData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, worksheet, "import");
            const wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
            saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), "csv_import.xlsx")
          }
          // Received result, stop spinners:
          operation.waiting=false;
          return resultData;
      })
      .catch((error) => {
          // The server request failed for some reason.
          console.error(error);
          operation.waiting=false;
          operation.result="FAIL";
          operation.message = error.responseText;
          throw new Error(error);
      })
  },

  registerNewCustomer:function() {
    var operation = AppModel.newCustomerForm.serverOperation;
    var customer = AppModel.newCustomerForm.customer;
    var adminUser = AppModel.newCustomerForm.adminUserForm.user;
    // When INSERT have been sent to server, until we receive
    operation.waiting=true;
    if(!customer.segment || typeof customer.segment  === 'undefined') {
      customer.segment = AppModel.customer_segments[0].id;
    }
    if(!customer.country_code || typeof customer.country_code  === 'undefined') {
      customer.country_code = AppModel.supportedCountries[0].country_code;
    }
    return ServerAPI.insertNewCustomer(customer, adminUser)
      .then((result) => {
        // Received result, stop spinners:
          operation.waiting=false;
          console.log(result);
          showTemporaryUIMessage(uiMsg('CMSG_NEW_CUSTOMER_INSERTED',"New customer inserted"));
          // If we have a customer list, add the new customer to it:
          if(AppModel.customerList.length>0) {
            AppModel.customerList.push(customer);
            // Also add it to the list used to show the Log in As customer list:
            AppModel.customerListIncludingOwnCompany.push(customer);
          }
          // Clear the registration form
          AppModel.newCustomerForm.reset();
      })
      .catch((error) => {
          // The server request failed for some reason.
          showTemporaryUIMessage(uiMsg('CMSG_COULD_NOT_REGISTER_CUSTOMER',"Could not register customer"));
          console.error(error);
          operation.waiting=false;
          operation.result="FAIL";
          operation.message = error.responseText;
          throw new Error(error);
      })

  },

  registerNewLocation:function() {
    var form = AppModel.newRoomForm;
    var operation = form.serverOperation;
    // When INSERT have been sent to server, until we receive
    operation.waiting=true;
    // If the location is set to "root", it really means "null"
    // the "root" value is due to the form UI
    if(form.location.id_parent=='root') {
      form.location.id_parent=null;
    }
    form.location.trimNumericFields();
    return ServerAPI.insertNewLocation( AppModel.id_customer,
                                        form.location)
      .then((result) => {
          // Received result, stop spinners:
          operation.waiting=false;
          showTemporaryUIMessage(uiMsg('CMSG_LOCATION_ADDED',"LOC added",form.location.name));
          // Inserting the new location into the location tree:
          transaction(function(){
            var newLocation = form.location.clone();
            // There is only supposed to be a single row returned with the ID
            // of the newly inserted location.
            console.log("inserting new location into tree");
            console.log(result[0]);
            console.log(newLocation);
            newLocation.id = result[0].id;
            if(newLocation.new_beacon_id !== undefined && newLocation.new_beacon_id !== null){
              utils.remove_beacon_from_appstate(newLocation.new_beacon_id);
              newLocation.beacons = [newLocation.new_beacon_id];
              newLocation.new_beacon_id = undefined;
            }
            // Finding the parent in the tree, if id_parent!=null
            if(newLocation.id_parent!=null) {
              var parent = AppModel.findLocationWithId(newLocation.id_parent);
              console.log("Found parent :");
              console.log(parent);
              newLocation.parent = parent;
              parent.children.push(newLocation);
              parent.children.sort(function(a,b){
                if(a.name < b.name) return -1;
                else if (a.name > b.name) return 1;
                else return 0;
              });
            }
            else
            {
              // Insert location as new root in the location tree:
              AppModel.userLocations.push(newLocation);
            }
            AppModel.newRoomForm.clearForNext();
          });
      })
      .catch((error) => {
          // The server request failed for some reason.
          console.error(error);
          operation.waiting=false;
          operation.result="FAIL";
          operation.message = error.responseText;
          throw new Error(error);
      })

  },
  fetch_customer_segments:function() {
    // If we already have the list, do nothing.
    if(AppModel.customer_segments.length>0) { return Promise.resolve(); };
    AppModel.fetching_customer_segments=true;
    return ServerAPI.getCustomerSegments()
    .then( segments => {
      AppModel.customer_segments=segments;
    })
    .catch( (error) => {
      console.log(error);
    })
    .finally( ()=> {
      AppModel.fetching_customer_segments=false;
    })
  },
  fetchSupportedCountries:function() {
    // If we already have the list, do nothing.
    if(AppModel.supportedCountries.length>0) { return Promise.resolve(); };
    AppModel.fetchingSupportedCountries = true;
    return ServerAPI.getSupportedCountries()
    .then( countryList => {
      AppModel.supportedCountries = countryList;
    })
    .catch( (error) => {
      console.log(error);
    })
    .finally( ()=> {
      AppModel.fetchingSupportedCountries = false;
    })
  },
  fetchSupportedLanguages:function() {
    // If we already have the list, do nothing.
    if(AppModel.supportedLanguages.length>0) { return Promise.resolve(); };
    AppModel.fetchingSupportedLanguages = true;
    return ServerAPI.getSupportedLanguages()
    .then( langList => {
      AppModel.supportedLanguages = langList;
    })
    .catch( (error) => {
      console.log(error);
    })
    .finally( ()=> {
      AppModel.fetchingSupportedLanguages = false;
    })
  },
  fetch_job_types:function() {
    // If we already have the list, do nothing.
    if(AppModel.job_types.length>0) { return Promise.resolve(); };
    AppModel.fetching_job_types = true;
    return ServerAPI.getJobTypes()
    .then( job_types => {
      AppModel.job_types = job_types.map(JobType.createFromDBRow);
    })
    .catch( (error) => {
      console.log(error);
    })
    .finally( ()=> {
      AppModel.fetching_job_types = false;
    })
  },
  fetch_customer_list:function(machine_name) {
    AppModel.customerListLoading=true;
    return ServerAPI.getCustomerListForDistributor(AppModel.id_customer, machine_name)
    .then( (res) =>{
      AppModel.customerList=res.map(Customer.createFromDBRow);
      // We also maintain a list of customers where we add in a dummy customer
      // object, representing the company of the currently logged in user.
      // It should only be used when displaying select-customer lists.
      AppModel.customerListIncludingOwnCompany = [];
      var ownCompany = new Customer();
      
      ownCompany.id = AppModel.userInfo.id_customer;
      ownCompany.name = AppModel.userInfo.customer_name;
      if (machine_name === 'undefined' || !machine_name) {
        AppModel.customerListIncludingOwnCompany.push(ownCompany);
      }

      AppModel.customerList.forEach(c=> AppModel.customerListIncludingOwnCompany.push(c));
      ServerAPI.getNextCustomerIdForDistributor(AppModel.id_customer)
      .then( res => {
        AppModel.nextCustomerId = res;
        return null;
      }).catch( (error) => {
        console.log(error);
      });
      return res;
    })
    .catch( (error) => {
      console.log(error);
    })
    .finally( ()=> {
      AppModel.customerListLoading=false;
    })
  },
  //
  fetch_relevant_machines:function() {
    // TODO : When should we re-fetch this list ?  See same comment on the
    // fetch_machine method.
    // If we have already loaded the machine-list.. :
    if(AppModel.machineListLastFetched || AppModel.fetchingMachineList) {
      return Promise.resolve(); };
    AppModel.fetchingMachineList=true;
    return ServerAPI.getUserMachines(AppModel.id_customer,AppModel.id_user)
      .then( (result) => {
        // console.log("There should be last_job_user_id here ",result);
        AppModel.machineList = result.map(Machine.createFromDBRow);
        return result;
      })
      .finally( ()=> {
        AppModel.fetchingMachineList=false;
        AppModel.machineListLastFetched=new Date();
        // Having updated the last_job jobs of the machines in the list,
        // we need to make sure that we don't have stale copies of the same
        // job in the AppModel.jobList
        AppModel.verifyJobListForLastJobs();
        // Having fetched machines we may have to start pulling for jobupdates:
        verifyStatusPullOperation();
      })
  },
  fetch_machines:function() {
    console.log("fetch_machines()");
    // If we already have the list, do nothing.
    // TODO : There is a difference between all machines for the customer
    // and only the "relevant" ones.  The machine list may thus be only partly
    // what is wanted when this method is required.
    if(AppModel.machineListLastFetched || AppModel.fetchingMachineList) {
      return Promise.resolve(); };
    AppModel.fetchingMachineList=true;
    return ServerAPI.getCustomerMachineList(AppModel.id_customer)
      .then( (result) => {
        console.log("There should be last_job_user_id here ",result);
        AppModel.machineList = result.map(Machine.createFromDBRow);
        return result;
      }).finally( ()=> {
        AppModel.fetchingMachineList=false;
        AppModel.machineListLastFetched=new Date();
        // Having updated the last_job jobs of the machines in the list,
        // we need to make sure that we don't have stale copies of the same
        // job in the AppModel.jobList
        AppModel.verifyJobListForLastJobs();
        // Having fetched machines we may have to start pulling for jobupdates:
        verifyStatusPullOperation();
      })
  },
  // Fetch recent jobs within a given user's domain
  fetch_recent_user_domain_jobs:function () {
    // If we have more than the jobs attached to machines as last jobs,
    // and all the jobs are loaded to at least DETAIL-level, then we don't
    // load them again :
    if(!AppModel.hasOnlyMachineLastJobs
        && AppModel.jobsLoadedToListLevel
        // If we only have one job loaded, we try to re-load regardless:
        && (AppModel.jobList && AppModel.jobList.length>1)
        && !AppModel.fetchingMoreJobs) {
      return Promise.resolve();
    };
    let oldestJob = AppModel.lastFetchedJobListTimestamp ? AppModel.lastFetchedJobListTimestamp : null;
    AppModel.fetchingJobList=true;
    
    return ServerAPI.getJobsInUserDomain(AppModel.id_customer,AppModel.id_user, oldestJob ? oldestJob.start_time : null)
      .then( (result) => {
        // TODO : Refactor this processing so that it can be used by all
        // job-fetching methods.
        // Some of these jobs may (or may not) be fetched together with the
        // machine-request. e.g. last job running for relevant machines.
        var allJobsIndex = AppModel.allJobsIndex();
        var domainJobsIndex = AppModel.domainJobsIndex();
        result.forEach( (res) => {
          var newJob = Job.createFromDBRow(res);
          if(newJob.key in allJobsIndex) {
            // Merge some key job-data :
            var job = allJobsIndex[newJob.key];
            job.updateFrom(newJob);
            // Then we use the existing job.
            newJob = job;
          }
          // If the job is not alreay in the domain-job list :
          if(!(newJob.key in domainJobsIndex)) {
            AppModel.jobList.push(newJob);
          }
        })
        AppModel.lastFetchedJobListTimestamp = result.length>0 ? result[result.length -1].start_time : null;
        return result;
      }).finally( ()=> {
        AppModel.fetchingJobList=false;
        AppModel.fetchingMoreJobs=false;
        AppModel.sortJobList();
        // Since we may have loaded new jobs, we need to make sure we don't
        // have Job objects representing the same Job in different place of the
        // app-state :
        AppModel.jobListLastFetched = new Date();
        AppModel.verifyJobListForLastJobs();
        // And Having fetched machines we may have to start pulling for jobupdates:
        verifyStatusPullOperation();
      })
  },
  // Loading sufficient data to display the dashboard page
  fetch_dashboard_data:function () {
    AppModel.fetchingDashboardData=true;
    return Promise.all([
      this.fetch_relevant_machines(),
      this.fetch_recent_user_domain_jobs()
    ])
    .finally(function(){
      AppModel.fetchingDashboardData=false;
    })
  },
  // Returns a promise of having loaded the user info for current logged in usr
  fetch_user_info:function () {
    // TODO: I have added loading of userInfo as part of the login-sequence.
    // So in theory the userInfo should never be null at this point, perhaps
    // we can remove this method entirely ?
    if(AppModel.userInfo!=null) {return Promise.resolve()};
    // When user info has been loaded, we update the newRoomForm :
    function patchNewRoomForm() {
      if(AppModel.userInfo.home_location!=null) {
        if(AppModel.newRoomForm.location.id_parent == null) {
          AppModel.newRoomForm.location.id_parent = AppModel.userInfo.home_location;
        }
      }
    }
    // If there is an ongoing loading of the user profile, we wait for it
    // to complete:
    if(AppModel.fetchingUserProfile) return new Promise(
      function(resolve,reject){
        when(
          () => !AppModel.fetchingUserProfile,
          () => { resolve(); }
        );
    }).then(()=>{
      patchNewRoomForm();
    });
    AppModel.fetchingUserProfile=true;
    return ServerAPI.getUserInfo(AppModel.id_customer,AppModel.id_user)
      .then(function(info) {
        AppModel.userInfo=info;
        // If the user has a home location, we try to set that as a default
        // for location-add-dialogue:
        patchNewRoomForm();
        AppModel.fetchingUserProfile=false;
      })
  },

  // Run a check to see if the customer id is unique or will cause trouble
  checkIfCustomerIdUnique(customer) {
    if(!customer.id) return Promise.resolve();
    AppModel.checkingCustomerId = true;
    return ServerAPI.checkIfCustomerIdExist(customer.id)
    .then(res => {
      if(res==true) {
        customer.id_checked = customer.id;
        customer.id_unique = false;
      } else {
        customer.id_checked = customer.id;
        customer.id_unique = true;
      }
    })
    .finally(()=>{
      AppModel.checkingCustomerId = true;
    })
  },

  // Run a check to see if the user currently being edited has a unique email
  // address
  checkIfEmailIsUnique(form) {
    let user = form.user;
    if(!user.validEmail) return Promise.resolve();
    form.checkingUniqueEmail = true;
    return ServerAPI.checkIfEmailExist(user.email)
    .then(res => {
      // TODO : If exist, set non-unique-email setting on user, else clear it.
      if(res==true) {
        user.email_checked = user.email;
        user.email_unique = false;
      } else {
        user.email_checked = user.email;
        user.email_unique = true;
      }
    })
    .finally(()=>{
      form.checkingUniqueEmail = false;
    })
  },
  //
  updateCustomer:function() {
    let form = AppModel.updateCustomerForm;
    var customer = form.customer;
    // The logic here is that if the user didn't pick any values
    // the select list just showed the first ones, which we then have
    // to set before updating:
    if(!customer.segment || typeof customer.segment  === 'undefined') {
      customer.segment = AppModel.customer_segments[0].id;
    }
    if(!customer.country_code || typeof customer.country_code  === 'undefined') {
      customer.country_code = AppModel.supportedCountries[0].country_code;
    }
    AppModel.updatingCustomerDetails= true;
    return ServerAPI.updateCustomerDetails(customer)
    .then( result => {
      // Update otherwise stale data in the customer list.
      AppModel.customerList.forEach( c => {
        if(c.id==customer.id) {
          c.updateFrom(customer);
        }
      })
      // Tell user that the update happened:
      showTemporaryUIMessage(uiMsg('CMSG_CUSTOMER_DATA_UPDATED',"Customer data updated "));
    })
    .finally(()=>{
      AppModel.updatingCustomerDetails = false;
      AppModel.updateCustomerForm.reset();
    })
  },

  deleteCustomer:function() {
    let form = AppModel.updateCustomerForm;
    var customer = form.customer;
    AppModel.updatingCustomerDetails= true;
    return ServerAPI.deleteCustomerDetails(customer)
    .then( result => {
      var customerIndex = AppModel.customerList.findIndex( (c) => {
        return c.id==customer.id
      });
      if(customerIndex!=-1) {
        AppModel.customerList.splice(customerIndex,1);
        AppModel.clearDeletionsListForReload();
      }
      // Tell user that the delete happened:
      showTemporaryUIMessage(uiMsg('CMSG_CUSTOMER_DATA_DELETED',"Customer deleted"));
    })
    .catch( error => {
      var errorMessage = uiMsg(error.responseText,"Customer could not be deleted");
      AppModel.uiError=errorMessage;
      throw new Error(errorMessage);
    })
    .finally(()=>{
      AppModel.updatingCustomerDetails = false;
      AppModel.updateCustomerForm.reset();
    })

  },

  fetch_edit_customer_details:function (params) {
    let form = AppModel.updateCustomerForm;
    form.reset();
    var id_customer = params.id_customer;
    AppModel.fetchingCustomerDetails= true;
    return ServerAPI.getCustomerDetails(id_customer)
    .then( row => {
      // Parse db data to create a customer object
      let customer = Customer.createFromDBRow(row);
      // copy data to the customer object on the update form:
      form.customer.updateFrom(customer);
    })
    .finally(()=>{
      AppModel.fetchingCustomerDetails = false;
    })
  },

  // Returns a promise of having loaded the user info for the selected user
  // And initialized the editUser form
  fetch_edit_user_details:function (params) {
    AppModel.updateUserForm.reset();
    var id_customer = params.id_customer;
    var id_user = params.id_user;
    // First we check if we already have this user in our list.
    console.log("See if we already have the user");
    if(id_customer==AppModel.id_customer) {
      var found = AppModel.userList.filter((u)=>{
        return u.id == id_user && u.roles.length>0;
      });
      console.log("found="+found);
      // If we already have the user, we copy info into the edit-form:
      if(found && found.length>0) {
        AppModel.updateUserForm.user.copyFieldsFrom(found[0]);
        // Holding on to the previous phone to be able to know if it was updated
        AppModel.updateUserForm.prev_phone = AppModel.updateUserForm.user.phone;
        // Holding on to the previous email to be able to know if it was updated
        AppModel.updateUserForm.prev_email = AppModel.updateUserForm.user.email;
        // Holding on to the previous id to be able to know if it was updated
        AppModel.updateUserForm.prev_id = AppModel.updateUserForm.user.id;
        // And the currently assigned roles :
        AppModel.updateUserForm.user.roles.forEach(r => {
          AppModel.updateUserForm.prev_roles.add(r.id_role);
        });
        AppModel.fetchingEditUserDetails=false;
        return Promise.resolve();
      }
    }
    // Fetch user data on user to edit from server :
    AppModel.fetchingEditUserDetails = true;
    console.log("calling ServerAPI.getUserInfo");
    return ServerAPI.getUserInfo(id_customer,id_user)
      .then(function(info) {
        console.log("Fetched user info");
        console.log(info);
        var loadedUser = User.createFromDBRow(info);
        AppModel.updateUserForm.user.copyFieldsFrom(loadedUser);
        // Holding on to the previous phone to be able to know if it was updated
        AppModel.updateUserForm.prev_phone = AppModel.updateUserForm.user.phone;
        // Holding on to the previous email to be able to know if it was updated
        AppModel.updateUserForm.prev_email = AppModel.updateUserForm.user.email;
        // Holding on to the previous id to be able to know if it was updated
        AppModel.updateUserForm.prev_id = AppModel.updateUserForm.user.id;
        // And the currently assigned roles :
        AppModel.updateUserForm.user.roles.forEach(r => {
          AppModel.updateUserForm.prev_roles.add(r.id_role);
        });
        // We also update the user object in the userList :
        var user = AppModel.userList.find((u)=>{
          return u.id == loadedUser.id;
        });
        if(user) user.copyFieldsFrom(loadedUser);
        AppModel.fetchingEditUserDetails=false;
      })
  },
  // Method to load a list of users for a given customer, used
  // to pick users by navigating by customer.  Does not modify the
  // userList for the current logged in user (shown in userAdmin page)
  fetch_userlist_for:function(customer) {
    console.log("fetch_userlist_for ",customer);
    AppModel.fetchingUserList=true;
    return ServerAPI.fetchUsersForCustomer(customer.id)
    .then((users) => {
      customer.users = users.map(User.createFromDBRow);
    })
    .finally(()=>{
      AppModel.fetchingUserList=false;
    })
  },
  // Request a new login-token and replace
  impersonate:function(id_customer,id_user, history) {
    AppModel.fetchingImpersonateToken=true;
    ServerAPI.getImpersonateToken(id_customer,id_user)
    .then((res) => {
      var newToken = res.token;
      switchUser(newToken,history);
    })
    .finally(()=>{
      AppModel.fetchingImpersonateToken=false;
    })
  },
  // Method to load a list of machines for a given customer, used
  // to pick machines by navigating by customer.  Does not modify the
  // machineList for the current logged in user (shown in userAdmin page)
  fetch_machinelist_for:function(customer) {
    console.log("fetch_machinelis_for ",customer);
    AppModel.fetchingMachineList=true;
    return ServerAPI.machineSearch({id_customer:customer.id,exclude_service_machines:true})
    .then((machines) => {
      let m = machines.map(Machine.createFromDBRow);
      customer.machines = m;      
      return m;
    })
    .finally(()=>{
      AppModel.fetchingMachineList=false;
    })
  },
  // Method to load a list of beacons for a given customer, used
  // to pick beacons by navigating by customer. (shown in userAdmin page)
  fetch_beaconlist_for:function(customer) {
    console.log("fetch_beaconlist_for ",customer);
    AppModel.fetchingBeaconList=true;
    return ServerAPI.getBeaconsForCustomer(customer.id)
    .then((beacons) => {
      customer.beacons = beacons.map(Beacon.createFromDBRow);
    })
    .finally(()=>{
      AppModel.fetchingBeaconsList=false;
    })
  },
  // Fetches the list of users relevant for the logged in user
  fetch_user_list:function () {
    // If the current user is admin for an entire customer, we should fetch
    // all users for that customer.
    // If the current user is administrating a selected customer, we should
    // fetch the user list for that customer.
    // Finally, if the current user has a home_location set, we should fetch
    // users only from that location domain.
    var loadPromise = null;
    if(AppModel.userList.length>0) {
        return Promise.resolve();
    }
    AppModel.fetchingUserList=true;
    if(AppModel.id_admin_customer!=null) {
      console.log("Fetching all users for a customer");
      loadPromise = ServerAPI.fetchUsersForCustomer(AppModel.id_admin_customer);
    }
    else if(AppModel.userInfo.id_home_location==null) {
      // Fetch all users for the customer
      console.log("Fetching all users for customer, as current user's home location is null");
      loadPromise = ServerAPI.fetchUsersForCustomer(AppModel.id_customer);
    }
    else {
      // Only fetch users within the location domain of the user
      loadPromise = ServerAPI.fetchUsersFromUserLocationDomain(
        AppModel.id_customer,AppModel.id_user
      );
    };
    return loadPromise.then((users) => {
      AppModel.userList = users.map(User.createFromDBRow);
      // If the currently logged in user is one of the users in the
      // user list, we change the entry in the list to point to the userInfo
      // object, to avoid inconsistencies when e.g. user info is updated.
      for(var i=0;i<AppModel.userList.length;i++) {
        if(AppModel.userList[i].id == AppModel.userInfo.id &&
          AppModel.userList[i].id_customer == AppModel.userInfo.id_customer) {
            // Make sure that userInfo is up to date with last update from DB:
            AppModel.userInfo.copyFieldsFrom(AppModel.userList[i]);
            // Then point the list entry to the userInfo object :
            AppModel.userList[i]=AppModel.userInfo;
          }
      }
    })
    .finally(()=>{
      AppModel.fetchingUserList=false;
    })

  },
  // Fetches the audit log based on filter params
  fetch_audit_log: function () {

    // Copy the object:
    let request = Object.assign({}, AppModel.auditLogSearchForm.request);

    // Ensure from date is at beginning of day
    if (request.date_from) {
      request.date_from = moment(request.date_from).startOf('day').toDate()
    }
    // Ensure to date is at end of day
    if (request.date_to) {
      request.date_to = moment(request.date_to).endOf('day').toDate();
    }

    AppModel.fetchingAuditLog = true;
    return ServerAPI.fetchAuditLog(request).then((auditLog) => {
      AppModel.auditLog = auditLog;
    }).catch(uiErrorDisplay).finally(() => {
      AppModel.fetchingAuditLog = false;
    })
  },
  // Loading locations available to this user:
  fetch_locations:function () {
    // Only load once
    if(AppModel.userLocations.length>0) { return Promise.resolve(); };
    // Helper function to re-build flattened location tree into tree structure:
    function organize_flat_tree(flat_tree) {
      // The location list we receive is a flattened tree.
      var id_to_node={};
      // Index the locations:
      flat_tree.forEach(function(loc) {
        id_to_node[loc.id]=loc;
        loc.children=[];
      });
      // Set up parent and child relations:
      flat_tree.forEach(function(loc) {
        // If the path only contains the id of the location itself:
        if(loc.path.length<2) {
          loc.parent=null;
        }
        else {
          var id_parent = loc.path[loc.path.length-2]
          loc.parent=id_to_node[id_parent];
          loc.id_parent=id_parent;
          // If we only load a subset of locations down the tree, we may not
          // have the actual parent :
          if(loc.parent) {
            loc.parent.children.push(loc);
          }
        }
      });
      // The location tree starts with the list of root-locations that do
      // not have a parent node :
      var rootLocations = flat_tree.filter(function(loc){
        return loc.parent==null;
      });
      return rootLocations;
    };
    AppModel.fetchingLocationData=true;
    // We fetch both user locations and user info in parallel
    var promises = [];
    promises.push(this.fetch_user_info());
    promises.push(
      ServerAPI.getUserLocations(AppModel.id_customer,AppModel.id_user)
        .then(function(locations) {
          locations = locations.map(Location.createFromDBRow)
          locations = locations.filter(function(l) { return !l.deleted });
          AppModel.userLocations=organize_flat_tree(locations);
          AppModel.fixDefaultJobTypesForRooms();
        })
    );
    return Promise.all(promises)
      .finally(function(){
        AppModel.fetchingLocationData=false;
      });
  },
  // When loading the new-user form, we need to set params from URL
  setup_new_user_details:function(params) {
    // Currently, there is only one parameter set through Route params,
    // the customer to register the new user under:
    AppModel.newUserForm.user.id_customer = params.id_customer;
    // Unless we are allowed to assign users to NULL locations, we pick the
    // first valid location as default new location for user
    if(!AppModel.allowAddingRootLocations) {
      // We have to wait until location data are not loading anymore :
      when(
        () => !AppModel.fetchingLocationData,
        () => {
          var location_options = AppModel.parentLocationChoices;
          if(!location_options || location_options.length==0) {
            console.error("We don't have any locations to set as default.")
          }
          else {
            AppModel.newUserForm.user.id_home_location = location_options[0].id;
          }
        });
    }
  },
  fetch_grantable_roles:function() {
    if(AppModel.grantableRoles.length>0) return Promise.resolve();
    AppModel.fetchingGrantableRoles = true;
    return ServerAPI.getGrantableRoles(AppModel.id_customer,AppModel.id_user)
      .then(function(roleList){
        AppModel.grantableRoles=roleList.map(Role.createFromDBRow);
        AppModel.fetchingGrantableRoles = false;
      });
  },
  // All details for either a running job or for a historic job :
  fetch_job_details:function(params) {
    // The job is identified by when it was run and on what machine
    var start_time = +params.startTime
    var id_machine = params.id_machine;
    AppModel.currentJob = AppModel.jobList.find( j => (
      j.id_machine==id_machine && j.start_time.getTime()==start_time)
    );
    // TODO : Verify how much data we need to load :
    if( AppModel.currentJob &&
        AppModel.currentJob.load_level==LoadLevel.DETAIL) return Promise.resolve();
    // We need to fetch the job data from the server
    AppModel.fetchingJobDetails=true;
    return ServerAPI.getJobsDetails(id_machine,start_time)
      .then( (jobreport) => {
        // The jobreport contains :
        // 1) a job-record
        // 2) a machine-record for the machine used
        // 3) measurements, an array for each sensor
        // 4) alarms - an array of the alarms triggered during the job
        // 5) phases - a record of each phase in the job
        console.log("JobReport");
        console.log(jobreport);
        var job = Job.createFromDBRow(jobreport.job);
        // We may already have the job in our jobList:
        job = AppModel.insertOrUpdateJob(job);
        // Add the additional data to the job-object:
        job.importSensors(jobreport.machine && jobreport.machine.sensors || []);
        job.importMeasurements(jobreport.measurements);
        job.importAlarms(jobreport.alarms);
        job.importPhases(jobreport.phases);
        // Flag that we have loaded this job-object to DETAIL-level
        job.load_level=LoadLevel.DETAIL;
        var machine = Machine.createFromDBRow(jobreport.machine);
        job.id_machine = machine.id;
        job.machine_action = machine.action;
        job.supported_features = machine.supported_features;
        job.machine_name = machine.name;
        machine = AppModel.insertOrUpdateMachine(machine);
        // If this job is still running, then we assume it was (and is) the
        // last job this machine ran:
        if(job.running) {
          machine.last_job=job;
        }
        AppModel.currentJob=job;
      })
      .catch(e => {
        console.error(e.responseText);
      })
      .finally( ()=> {
        console.log("setting AppModel.fetchingJobDetails=false;")
        AppModel.fetchingJobDetails=false;
        // Since we may have loaded new jobs, we need to make sure we don't
        // have Job objects representing the same Job in different places of the
        // app-state :
        AppModel.verifyJobListForLastJobs();
        // And if the job is running, we need to keep pulling its status :
        verifyStatusPullOperation();
      })
  },
  // Check if the username is taken already
  checkUsernameAvailability:function(userForm) {
    var user = userForm.user;
    // Until we get a response from server, the username has not checked out.
    user.login_checked = false;
    userForm.checkingAvailability = true;
    return ServerAPI.userExists(user.id_customer,user.id)
    .then( exist => {
      user.login_unique=!exist;
      user.login_checked=true;
      return null;
    })
    .finally( ()=> {
      userForm.checkingAvailability = false;
    })
  },
  // Fetch the list of job types available for this customer
  fetch_customer_job_types:function() {
    // If we already have fetched the list :
    if(AppModel.availableJobTypes.length>0) return Promise.resolve();
    AppModel.fetchingAvailableJobTypes=true;
    return ServerAPI.getCustomerJobTypes(AppModel.id_customer)
    .then( typelist => {
      AppModel.availableJobTypes=typelist.map(JobType.createFromDBRow);
      AppModel.fixDefaultJobTypesForRooms();
    })
    .finally( () => {
      AppModel.fetchingAvailableJobTypes=false;
    })
  },
  fetch_recent_deletions:function() {
    // If we already have fetched the list :
    if(AppModel.deletions) return Promise.resolve();
    AppModel.fetchingDeletions=true;
    return ServerAPI.findRecentDeletions(AppModel.id_customer,30)
    .then( deletions => {
      console.log(deletions);
      deletions.user_deletions.forEach( d => {
        d.deleted_ts = new Date(d.deleted_ts);
      });
      deletions.location_deletions.forEach( d => {
        d.deleted_ts = new Date(d.deleted_ts);
      });
      AppModel.deletions=deletions;
    })
    .finally( () => {
      AppModel.fetchingDeletions=false;
    })
  },
  // returns a promise of having undeleted the user
  undeleteUser:function(id_user) {
    AppModel.restoringDeletion = true; // For UI to show wait-indicator
    return ServerAPI.restoreUser(AppModel.id_customer, id_user)
    .then( result => {
      showTemporaryUIMessage(uiMsg('CMSG_USER_RESTORED',"User restored"));
      // If we undeleted a user, we should probably re-load user
      // data next time before showing the User Admin page.
      AppModel.clearUserListDataForReload();
      AppModel.clearLocationDataForReload();
      // Remove the delete from the deltion list
      if(AppModel.deletions && AppModel.deletions.user_deletions) {
        AppModel.deletions.user_deletions =
          AppModel.deletions.user_deletions.filter( d => d.id != id_user);
      }
      return utils.fetch_user_list();
    })
    .catch(uiErrorDisplay)
    .finally( () => {
      AppModel.restoringDeletion=false;
    })

  },
  // returns a promise of having undeleted the locations
  // This is used from the Delete/Trash page to restore a deleted location
  undeleteLocations:function(deletion_timestamp) {
    AppModel.restoringDeletion = true; // For UI to show wait-indicator
    return ServerAPI.restoreLocations(AppModel.id_customer, deletion_timestamp)
    .then( () => {
      showTemporaryUIMessage(uiMsg('CMSG_LOCATION_RESTORED',"Location(s) restored"));
      // If we undeleted locations, we should reload location data:
      AppModel.clearLocationDataForReload();
      // Then we remove the deletion line that we have restored :
      if(AppModel.deletions && AppModel.deletions.location_deletions) {
        AppModel.deletions.location_deletions =
          AppModel.deletions.location_deletions.filter( d =>
            d.deleted_ts != deletion_timestamp);
      }
    })
    .catch(uiErrorDisplay)
    .finally( () => {
      AppModel.restoringDeletion=false;
    })
  },
  // returns a promise of having undeleted the locations
  // The location id provided will be used to find the set of locations
  // This is used as the UNDO action right after a user has performed a
  // delete operation.
  undeleteLocationsById:function(id_location) {
    AppModel.restoringDeletion = true; // For UI to show wait-indicator
    return ServerAPI.restoreLocationsById(AppModel.id_customer, id_location)
    .then( () => {
      showTemporaryUIMessage(uiMsg('CMSG_LOCATION_RESTORED',"Location(s) restored"));
      // If we undeleted locations, we should reload location data:
      AppModel.clearLocationDataForReload();
      AppModel.clearDeletionsListForReload();
      // Reload the location list :
      return utils.fetch_locations();
    })
    .catch(uiErrorDisplay)
    .finally( () => {
      AppModel.restoringDeletion=false;
    })
  },
  // When user submits the filled in machine configuration form:
  updateMachineConfiguration:function() {
    AppModel.updatingMachineConfig = true; // For UI to show working-indicator
    let form = AppModel.machineConfigurationForm;
    return ServerAPI.updateMachineConfig(
      form.machine.id, // Id of machine to update
      form.parameters.map(p => p.valueObject)// Array of prop, value setttings
    )
    .then( () => {
      showTemporaryUIMessage(uiMsg('CMSG_CONFIG_STORED',"Configuration stored"));
    })
    .catch(uiErrorDisplay)
    .finally( () => {
      AppModel.updatingMachineConfig = false;
    })
  },
  // When user resets the machine configuration parameters:
  resetToDefaults:function() {
    AppModel.resettingMachineConfig = true; // For UI to show working-indicator
    let form = AppModel.machineConfigurationForm;
    return ServerAPI.resetMachineConfig(
      form.machine.id // Id of machine to reset
    )
    .then( () => {
      showTemporaryUIMessage(uiMsg('CMSG_CONFIG_RESET',"Configuration reset"));
    })
    .catch(uiErrorDisplay)
    .finally( () => {
      AppModel.resettingMachineConfig = false;
    })
  },
  // Using the data in the updateUserForm
  sendPhoneNumberVerification:function() {
    AppModel.sendingPhoneVerificationCode=true;
    return ServerAPI.sendVerifyCode(
      AppModel.updateUserForm.user.id_customer,
      AppModel.updateUserForm.user.id,
      AppModel.updateUserForm.user.phone
    )
    .catch( error => {
      AppModel.uiError="We are unable to send an SMS to the number provided.  Please verify that it is a valid phone number, including country code";
      throw new Error(error.responseText);
    })
    .finally( () => {
      AppModel.sendingPhoneVerificationCode=false;
    })
  },
  // Using the data in the updateUserForm
  checkPhoneNumberVerificationCode:function(code) {
    AppModel.verifyingPhoneOperation=true;
    return ServerAPI.checkVerifyCode(
      AppModel.updateUserForm.user.id_customer,
      AppModel.updateUserForm.user.id,
      AppModel.updateUserForm.user.verifycode
    )
    .then( (result) => {
      console.log("Result from verification server call",result);
      // We copy the values to the update form, as that may influence the
      // UI display if an admin is on the user_edit page
      AppModel.updateUserForm.user.phone_verified = result.phone_verified;
      AppModel.updateUserForm.user.phone = result.phone;
      // If the logged in user is the same as the user that just had his/her
      // phone confirmed, update user Info :
      if(AppModel.userInfo.id == AppModel.updateUserForm.user.id &&
        AppModel.userInfo.id_customer == AppModel.updateUserForm.user.id_customer) {
          AppModel.userInfo.phone_verified = result.phone_verified;
          AppModel.userInfo.phone = result.phone;
      } else {
        // If we confirmed the phone number for another user (as admin)
        // we have to find that user and update the data for him/her:
        AppModel.userList
          .filter( u => (
            u.id == AppModel.updateUserForm.user.id &&
            u.id_customer == AppModel.updateUserForm.user.id_customer)
          ) // We only expect there to be none or one:
          .forEach( u => {
            u.phone_verified = result.phone_verified;
            u.phone = result.phone;
          })
      }
    })
    .finally( () => {
      AppModel.verifyingPhoneOperation=false;
    })
  },
  setup_new_customer_form:function() {
    AppModel.newCustomerForm.reset();
    // We set the distributor Id (though it will be overwritten with the
    // id_customer of logged in user on the server as a integrity/security measure.)
    AppModel.newCustomerForm.customer.id_distributor = AppModel.userInfo.id_customer;
  },
  // Fetch the list of contracts for a given customer/machin combo
  fetch_customer_machine_contracts:function(params) {
    let id_customer = params.id_customer;
    let id_machine = params.id_machine;
    AppModel.contractListLoading = true;
    return ServerAPI.fetchCustomerMachineContracts(id_customer, id_machine)
    .then(  contractList => {
      console.log("contractList",contractList);
      AppModel.contractList = contractList.map(Contract.createFromDBRow)
      return null;
    })
    .catch( (error) => {
      console.log(error);
      AppModel.uiError="Unable to fetch data for machine. Check internet connection.";
    })
    .finally( ()=> {
      AppModel.contractListLoading = false;
    })
  },
  // Helper method that sets the support contract date for the
  // new contract form to the day after the last known end date
  // We call this method from both the fetch_contract_form_context
  // and setup_new_contract_form method, as we don't know which
  // one of them will finnish first and thus when the last support
  // date will be availble.
  fix_contract_start_date() {
    if(AppModel.contractForm.last_support_till &&
      !AppModel.contractForm.contract.delivery) {
      // For new contracts that does not have a delivery date set,
      // Place the new contract one day after the last one ends:
      let startContract = AppModel.contractForm.last_support_till;
      startContract = new Date(startContract.setDate(startContract.getDate()+1))
      AppModel.contractForm.contract.delivery = startContract;
    }
  },

  // Fetch data on the customer and the machine for editing contract:
  fetch_contract_form_context:function(params) {
    let id_machine = params.id_machine;
    let id_customer = params.id_customer;
    AppModel.fetchingContractFormContext = true;
    // First see if we have the customer in the customerList :
    let customer = AppModel.customerList.find(c => c.id == id_customer);
    // Then see if we have the customer in the contractForm already:
    if(!customer
      && AppModel.contractForm.customer
      && AppModel.contractForm.customer.id==id_customer) {
        customer = AppModel.contractForm.customer;
      }
    // If not load :
    let customerPromise = customer ? Promise.resolve(customer) :
      ServerAPI.getCustomerDetails(id_customer).then( row =>
        Customer.createFromDBRow(row)
      )
    // See if we have the machine details, or load them :
    let machine = AppModel.machineList.find(m => m.id == id_machine);
    // Check that we haven't loaded the machine into the contract form already
    if(!machine
      && AppModel.contractForm.machine
      && AppModel.contractForm.machine.id==id_machine) {
        machine = AppModel.contractForm.machine;
      }
    let machinePromise = machine ? Promise.resolve(machine) :
      ServerAPI.getMachineDetails(id_customer,id_machine).then( row =>
        Machine.createFromDBRow(row)
      )
    return Promise.all([
      customerPromise,
      machinePromise
    ])
    .spread( (customer, machine) => {
      AppModel.contractForm.customer = customer;
      AppModel.contractForm.machine = machine;
      console.log("fetchCustomerMachineContracts");
      return ServerAPI.fetchCustomerMachineContracts(customer.id, machine.id)
    })
    .then(contractList => {
      // Find the last date of a support contract :
      let support_dates = contractList.map(Contract.createFromDBRow)
        .filter(c => c.type=='Support') // Only look at support contracts
        .map( c => +c.support_paid_till) // Pick their last date (as number)
        .sort() // Numerical sort
        .reverse() // reverse to get oldest date first
      if(support_dates.length > 0) {
        AppModel.contractForm.last_support_till = new Date(support_dates[0]);
        // See if the date of the new contract form should be set
        utils.fix_contract_start_date();
      }
    })
    .finally(()=>{
      AppModel.fetchingContractFormContext = false;
    })
  },
  // Fetch data on the customer and the machine for editing contract:
  fetch_contract_details:function(params) {
    let id_customer = params.id_customer;
    let id_contract = params.id_contract;
    AppModel.contractDetailLoading = true;
    return ServerAPI.getContract(id_customer, id_contract)
    .then(  row => {
      AppModel.contractForm.contract = Contract.createFromDBRow(row)
      return null;
    })
    .finally( ()=> {
      AppModel.contractDetailLoading = false;
    })
  },
  updateContract:function(contract) {
    AppModel.updatingContractData = true;
    return ServerAPI.updateContract(contract)
    .then( res => {
      showTemporaryUIMessage(uiMsg('CMSG_CONTRACT_UPDATED',"Contract updated"));
      return null;
    })
    .catch(uiErrorDisplay)
    .finally( ()=> {
      AppModel.updatingContractData = false;
    })
  },
  setup_new_contract_form:function(params) {
    AppModel.contractForm.reset();
    let contract = AppModel.contractForm.contract;
    // What should be the default contract form and sensible default date ?
    contract.type = 'Support';
    // See if the date of the new contract form should be set
    utils.fix_contract_start_date();
    return Promise.resolve();
  },
  insertContract:function(contract) {
    AppModel.updatingContractData = true;
    contract.created_at = new Date();
    return ServerAPI.insertContract(contract)
    .then( res => {
      showTemporaryUIMessage(uiMsg('CMSG_CONTRACT_INSERTED',"Contract inserted"));
      return null;
    })
    .catch(uiErrorDisplay)
    .finally( ()=> {
      AppModel.updatingContractData = false;
    })
  },
  fetch_simcard_information:function() {
    AppModel.fetchingSimCards = true;
    
    if(AppModel.simCards.length > 0) {
      AppModel.fetchingSimCards = false;
      return Promise.resolve(AppModel.simCards)
    }
    return ServerAPI.getSimCardInfo('all')
    .then( simcards  => {
      AppModel.simCards = simcards.map(SimCard.createFromDBRow);
      return simcards
    })
    .catch(uiErrorDisplay)
    .finally( ()=> {
      AppModel.fetchingSimCards = false;
    })
  },
  fetch_subscription_information:function(){
    if(AppModel.dataSubscriptions.length > 0 && AppModel.smsSubscriptions.length > 0){
      return Promise.resolve(true);
    }
    return ServerAPI.getSIMSubscription()
    .then(subs => {
      AppModel.dataSubscriptions = subs.filter(sub => sub.type == 'DATA');
      AppModel.smsSubscriptions = subs.filter(sub => sub.type == 'SMS');
      return true;
    })
  },
  fetch_simcard_details:function(params) {
    let phone = params.phoneNumber;
    AppModel.fetchingSimCardDetails = true;
    return ServerAPI.getSimCardDetails(phone)
    .then( result => {
      AppModel.simCardUsage = result.usage.map(point => {
        let month = moment(new Date(point.date)).format("MMMM");
        return [ month, point.amount ];
      });
      AppModel.simCardLocationData = result.location      
      AppModel.roamingStatus = result.roaming;
    }).catch(error => {
        uiErrorDisplay(error);
    }).finally(() => {
      AppModel.fetchingSimCardDetails = false;
    })
  },
  registerSimCards:function(form) {
    return ServerAPI.registerSimCards(form)
    .then( res => {
      showTemporaryUIMessage("SIM-card(s) added");
      return true
    })
    .catch(error => {
        uiErrorDisplay(error);
    })
  },
  updateSimCard:function(form) {
    AppModel.updatingSimCard = true;
    return ServerAPI.updateSimCard(form)
    .then( res => {
          console.log(result);
          let i = AppModel.simCards.findIndex(sim => sim.iccid == res.iccid)
          
          AppModel.simCards[i].status = res.sim.status;
          AppModel.simCards[i].data = res.data;
          AppModel.simCards[i].sms = res.sms;
          AppModel.simCards[i].dataId = res.dataId;
          AppModel.simCards[i].smsId = res.smsId;

          showTemporaryUIMessage("SIM-card updated");
          return true
        
    })
    .catch(error => {
      if(error.status == 412){
        showTemporaryUIMessage(error.error)
      }else{
        uiErrorDisplay(error);
      }
    })
    .finally( ()=> {
      AppModel.updatingSimCard = false;
    })
  },
  // This method is called whenever the route changes to verify or loading
  // sufficient data for the particular route. The dataset name is the
  // one set as route-config in index.js file.
  requireDataset:function(dataset,params) {
    // When a data-set is required, we register a task to load the data as
    // soon as the loggedIn status is true.
    console.log("Dataset requested",dataset,params);
    when(
      () => AppModel.loggedIn && !AppModel.missingUserProfile,
      () => {
        //console.log("Dataset has been required : "+dataset);
        // For data-set loading operations that return a promise :
        var loadPromise = null;
        if(dataset=="user_dashboard") {
          loadPromise = this.fetch_dashboard_data();
        }
        if(dataset=="customer_list") {
          loadPromise = this.fetch_customer_list();
        }
        if(dataset=="customer_edit_details") {
          loadPromise = this.fetch_edit_customer_details(params);
        }
        if(dataset=="recent_jobs") {
          loadPromise = this.fetch_recent_user_domain_jobs();
        }
        if(dataset=="machines") {
          loadPromise = this.fetch_relevant_machines();
        }
        if(dataset=="machine_details") {
          loadPromise = this.fetch_machine_details(params);
        }
        if(dataset=="machine_config_details") {
          loadPromise = this.fetch_machine_config_details(params);
        }
        if(dataset=="machine_history"){
          loadPromise = this.fetch_machine_history(params);
        }
        if(dataset=="rooms") {
          loadPromise = this.fetch_locations();
        }
        if(dataset=="beacons") {
          loadPromise = this.fetch_customer_list();
        }
        if(dataset=="location_details") {
          loadPromise = this.fetch_location_details(params);
        }
        if(dataset=="user_info") {
          loadPromise = this.fetch_user_info();
        }
        if(dataset=="edit_user_details") {
          loadPromise = this.fetch_edit_user_details(params);
        }
        if(dataset=="user_list") {
          loadPromise = this.fetch_user_list();
        }
        if(dataset=="audit_log") {
          loadPromise = this.fetch_audit_log();
        }
        if(dataset=="grant_roles") {
          loadPromise = this.fetch_grantable_roles();
        }
        if(dataset=="job_details") {
          loadPromise = this.fetch_job_details(params);
        }
        if(dataset=="location_types") {
          loadPromise = this.loadLocationTypes();
        }
        if(dataset=="customer_job_types") {
          loadPromise = this.fetch_customer_job_types();
        }
        if(dataset=="recent_deletions") {
          loadPromise = this.fetch_recent_deletions();
        }
        if(dataset=="customer_segments") {
          loadPromise = this.fetch_customer_segments();
        }
        if(dataset=="job_types") {
          loadPromise = this.fetch_job_types();
        }
        if(dataset=="country_list") {
          loadPromise = this.fetchSupportedCountries();
        }
        if(dataset=="language_list") {
          loadPromise = this.fetchSupportedLanguages();
        }

        if(dataset=="machine_assign_form") {
          loadPromise = this.setupMachineAssignmentForm(params);
        }
        if(dataset=="machine_contracts") {
          loadPromise = this.fetch_customer_machine_contracts(params);
        }
        if(dataset=="contract_context") {
          loadPromise = this.fetch_contract_form_context(params);
        }
        if(dataset=="contract_detail") {
          loadPromise = this.fetch_contract_details(params);
        }
        if(dataset=="new_contract_form") {
          loadPromise = this.setup_new_contract_form(params);
        }
        if(dataset=="simcards"){
          loadPromise = this.fetch_simcard_information();
        }
        if(dataset=="simcard"){          
          loadPromise = this.fetch_simcard_details(params);
        }
        if(dataset=="subscription"){
          loadPromise = this.fetch_subscription_information();
        }

        // This does not return a promise :
        if(dataset=="new_user_details") { this.setup_new_user_details(params); }
        // Setting up new room form with some sensible defaults:
        if(dataset=="new_room_form") AppModel.newRoomForm.reset();
        if(dataset=="duplicate_room_form") AppModel.newRoomForm.duplicateReset();
        if(dataset=="new_customer_form") {
          this.setup_new_customer_form();
        }

        // To make sure we dump som error messages of data loading promises fail
        if(loadPromise!=null) {
          loadPromise
          .then( (res) => {
            console.log("Dataset: "+dataset+" promise resolved",res);
          })
          .catch( (err) => {
            console.log("Error loading dataset : "+dataset);
            console.log(err);
            console.log(err.stack);
          })
        }
      }
    );
  }
}

/*
  We wait for a user to be logged in before we load the right translations
  for the UI.
*/
autorun( ()=> {
  if(AppModel.loggedIn
  && !AppModel.missingUserProfile
  && AppModel.userInfo ) {
    ServerAPI.fetchMessageDefinitions(AppModel.userInfo.language || 'EN')
    .then( messages => {
      installLanguage(messages);
    })
    // If user language has been changed, we refresh the locale and timeZone
    // settings :
    .then( () => {
      return ServerAPI.getUserInfo(AppModel.id_customer,AppModel.id_user)
      .then( userInfo => {
        transaction(()=>{
          AppModel.time_zone = userInfo.timezone;
          AppModel.locale = userInfo.locale_code;
        })
      })
    })
    .then( ()=> {
      return null;
    })
  }
})

export default utils;



/** WEBPACK FOOTER **
 ** ./src/DataModel/AppModelUtils.js
 **/